import React from "react";
import "../admin/table.css";
import { getInitials } from "./functions";
import More from "./more.png";
import { useState } from "react";
import { useEffect } from "react";
import Delete from "./delete.png";
const moment = require('moment');


export function Berlesek_Table() {
    const url = process.env.REACT_APP_API_URL;
    const [berlesek, setberlesek] = useState([]);
    const [loading, setLoading] = useState([]);
    const [Error, setError] = useState([]);

    const [moreOpen, setmoreOpen] = useState(false);

    const [newBerlesVisible, setNewBerlesVisible] = useState(false); // Új állapot a láthatóság kezelésére
    const [newBerles, setNewBerles] = useState({
      nev: "",
      berles_kezdete: "",
      berles_vege: "",
      szolgaltatas: "tuzolto",
      email: "",
      telefonszam: "",
      uzenet: "",
    });
    
    const handleNewBerlesSubmit = async (e) => {
      e.preventDefault();
      console.log(newBerles);
      try {
        const response = await fetch(url + '/foglalas', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(newBerles),
        });
        if (response.ok) {
          const result = await response.json();
          alert('Új bérlés sikeresen hozzáadva!');
          setNewBerles({
            nev: '',
            berles_kezdete: '',
            berles_vege: '',
            szolgaltatas: 'tuzolto',
            email: '',
            telefonszam: '',
            uzenet: '',
          });
          // Frissítsd a bérlések listáját
          setberlesek((prevBerlesek) => [...prevBerlesek, result.newBerles]);
          setNewBerlesVisible(false);
        } else {
          console.error('Hiba történt az új bérlés hozzáadásakor.');
        }
      } catch (error) {
        console.error('Hiba történt a kérés során:', error);
      }
    };
    
 

     useEffect(() => {
        async function fetchFoglalasok() {
          try {
            const response = await fetch(url+"/api/admin/foglalasok", {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'include'
            });
    
            if (!response.ok) {
              throw new Error('Hálozati probléma');
            }
    
            const data = await response.json();
            console.log('API response:', data);
            if (Array.isArray(data)) {
              const fetchedFoglalasok = data.map(foglalas => ({
                id: foglalas.id,
                berles_kezdete: moment(new Date(foglalas.berles_kezdete)).format('YYYY.MM.DD'),
                berles_vege: moment(new Date(foglalas.berles_vege)).format('YYYY.MM.DD'),
                nev: foglalas.nev,
                email: foglalas.email,
                telefonszam: foglalas.telefonszam,
                uzenet: foglalas.uzenet,
                szolgaltatas: foglalas.szolgaltatas
              }));
              setberlesek(fetchedFoglalasok);
            } else {
              console.error('Nem taláható foglalás');
              setberlesek([]);
            }
          } catch (error) {
            setError(error.message);
            console.error('Hiba az adateléréssel', error);
            setberlesek([]);
          } finally {
            setLoading(false);
          }
        }


        
        fetchFoglalasok();
      }, []);


      async function handleDelete(id) {
        if (window.confirm("Biztosan törölni szeretnéd ezt a foglalást?")) {
          try {
            const response = await fetch(url + '/api/admin/foglalas/torles', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({id}),
            });
            const result = await response.json();
            if (response.ok && result.success) {
              alert('Sikeres Törlés');
              setberlesek(prevBerlesek => prevBerlesek.filter(order => order.id !== id)); // Sor eltávolítása
            } else {
              console.error('Hiba történt a törlés során:', result);
            }
          } catch (error) {
            console.error('Hiba történt a kérés során:', error);
          }
        }
      }
  
      const [moreOpenId, setMoreOpenId] = useState(null);

function handleMore(id) {
  if (moreOpenId === id) {
    setMoreOpenId(null); // Ha ugyanarra kattint, bezárja
  } else {
    setMoreOpenId(id); // Új sort nyit meg
  }
}


    const orders = [
        {
          id: 1,
          nev: "Kiss Péter",
          berles_kezdete: "2025-01-15",
          berles_vege: "2025-01-20",
          szolgaltatas: "Tűzoltóautó bérlés",
          email: "peter.kiss@example.com",
          telefonszam: "+36 30 123 4567",
          uzenet: "Születésnapi rendezvényhez szeretnénk bérelni a tűzoltóautót."
        },
        {
          id: 2,
          nev: "Nagy Anna",
          berles_kezdete: "2025-02-01",
          berles_vege: "2025-02-05",
          szolgaltatas: "UAZ terepjáró bérlés",
          email: "anna.nagy@example.com",
          telefonszam: "+36 20 987 6543",
          uzenet: "Kalandtúrára lenne szükségünk egy strapabíró terepjáróra."
        },
        {
          id: 3,
          nev: "Szabó János",
          berles_kezdete: "2025-03-10",
          berles_vege: "2025-03-12",
          szolgaltatas: "Mentőautó biztosítás",
          email: "janos.szabo@example.com",
          telefonszam: "+36 70 456 7890",
          uzenet: "Egy sporteseményhez szeretnénk mentőautót biztosítani."
        },
        {
          id: 4,
          nev: "Tóth Éva",
          berles_kezdete: "2025-04-05",
          berles_vege: "2025-04-07",
          szolgaltatas: "Tűzoltóautó bérlés",
          email: "eva.toth@example.com",
          telefonszam: "+36 30 876 5432",
          uzenet: "Filmforgatáshoz lenne szükségünk egy klasszikus tűzoltóautóra."
        },
        {
          id: 5,
          nev: "Varga László",
          berles_kezdete: "2025-05-20",
          berles_vege: "2025-05-25",
          szolgaltatas: "UAZ terepjáró bérlés",
          email: "laszlo.varga@example.com",
          telefonszam: "+36 20 345 6789",
          uzenet: "Off-road versenyre bérelnénk egy UAZ terepjárót."
        }
      ];
      
      
      

    return (
        <div className="berles-szoveg">
            <h1>Bérlések</h1>
            <div className="berlesek-container">
                <table className="orders-table">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Bérlő</th>
                        <th>Bérlés kezdete</th>
                        <th>Bérlés vége</th>
                        <th>Szolgáltatás</th>
                        <th>Email</th>
                        <th>Telefonszám</th>
                        <th>Változtatás</th>
                    </tr>
                    </thead>
                    <tbody className="berles-adatok">
                      <div className="hozzaad-plusz-container">
                      <button
                        className="hozzaad-plusz-button"
                        onClick={() => setNewBerlesVisible(!newBerlesVisible)} // Láthatóság váltása
                      >
                        +
                      </button>
                      </div>
                      {newBerlesVisible && (
                        <div className="berles-hozzaad-container">
                          <p>Új Bérlés felvitele</p>
                          <form className="berles-form" onSubmit={handleNewBerlesSubmit}>
                            <div className="form-group">
                              <label htmlFor="nev">Bérlő neve:</label>
                              <input
                                type="text"
                                id="nev"
                                value={newBerles.nev}
                                onChange={(e) =>
                                  setNewBerles({ ...newBerles, nev: e.target.value })
                                }
                                required
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="berles_kezdete">Bérlés kezdete:</label>
                              <input
                                type="date"
                                id="berles_kezdete"
                                value={newBerles.berles_kezdete}
                                onChange={(e) =>
                                  setNewBerles({
                                    ...newBerles,
                                    berles_kezdete: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="berles_vege">Bérlés vége:</label>
                              <input
                                type="date"
                                id="berles_vege"
                                value={newBerles.berles_vege}
                                onChange={(e) =>
                                  setNewBerles({ ...newBerles, berles_vege: e.target.value })
                                }
                                required
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="szolgaltatas">Szolgáltatás:</label>
                              <select
                                name="szolgaltatas"
                                id="szolgaltatas"
                                value={newBerles.szolgaltatas}
                                onChange={(e) =>
                                  setNewBerles({
                                    ...newBerles,
                                    szolgaltatas: e.target.value,
                                  })
                                }
                                required
                              >
                                 <option value="tuzolto">Tűzoltó</option>
                                 <option value="uaz">Uaz</option>
                                </select>
                            </div>
                            <div className="form-group">
                              <label htmlFor="email">Email:</label>
                              <input
                                type="email"
                                id="email"
                                value={newBerles.email}
                                onChange={(e) =>
                                  setNewBerles({ ...newBerles, email: e.target.value })
                                }
                                required
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="telefonszam">Telefonszám:</label>
                              <input
                                type="tel"
                                id="telefonszam"
                                value={newBerles.telefonszam}
                                onChange={(e) =>
                                  setNewBerles({ ...newBerles, telefonszam: e.target.value })
                                }
                                required
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="uzenet">Üzenet:</label>
                              <textarea
                                id="uzenet"
                                value={newBerles.uzenet}
                                onChange={(e) =>
                                  setNewBerles({ ...newBerles, uzenet: e.target.value })
                                }
                              />
                            </div>
                            <button type="submit">Mentés</button>
                          </form>
                        </div>
                      )}
                    {berlesek.map(order => (
                        <tr key={order.id}>
                        <td>{order.id}</td>
                        <td>
                            <div className="nev-container">
                                <div className="profilkep">
                                    {getInitials(order.nev)}
                                </div>
                                <p>{order.nev}</p>
                            </div>
                            
                            </td>
                        <td>{order.berles_kezdete}</td>
                        <td>{order.berles_vege}</td>
                        <td>{order.szolgaltatas}</td>
                        <td>{order.email}</td>
                        <td>{order.telefonszam}</td>
                        <td>
                          <div className="actions-container">
                            <div className="more-container" onClick={() => handleMore(order.id)}>
                                <img className="more" src={More}></img>
                            </div>
                            {moreOpenId === order.id && ( // Feltételes megjelenítés
                              <div className="more-dolgok">
                                <img
                                  className="delete-gomb"
                                  onClick={() => handleDelete(order.id)}
                                  src={Delete}
                                  alt="Delete"
                                />
                                </div>)}
                          </div>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
    </div>
    );
  }
  